// extracted by mini-css-extract-plugin
export default {"ProductListFlex":"ProductList_ProductListFlex__tfFQA"};